export default {
  startingDate: "2020-06-13",
  notificationTitle: "",
  notificationType: "success"
}